import { BannerStyleMode } from './BannerStyleChoice';

export const BANNER_PROMPT_TEMPLATE = '商品名：○○\n誰向け：○○な人\n伝えたい魅力：○○\n画像に載せる文言：○○';

export interface BannerReadinessInput {
  starting: boolean;
  mode: 'product' | 'freetext';
  hasProduct: boolean;
  prompt: string;
  styleMode: BannerStyleMode;
  styleCount: number;
  imageCount: number;
  capacityMessage?: string | null;
  sizeError: string | null;
  /** 選んだ商品の情報を URL から取得中（自動スタイルは取得が終わるまで選べない） */
  productFetching?: boolean;
}

export function getBannerReadiness(input: BannerReadinessInput): { message: string; target?: 'product' | 'prompt' | 'style' | 'count' | 'size' } | null {
  if (input.starting) return { message: '生成の開始を受け付けています。そのままお待ちください。' };
  if (input.mode === 'product' && !input.hasProduct) return { message: 'まず、広告にする商品を選んでください。', target: 'product' };
  if (input.mode === 'freetext' && !input.prompt.trim()) return { message: '作りたい広告の内容を入力してください。', target: 'prompt' };
  if (input.mode === 'freetext' && input.prompt.trim() === BANNER_PROMPT_TEMPLATE) return { message: '入力例の「○○」を、商品名や伝えたい内容に書き換えてください。', target: 'prompt' };
  if (input.imageCount < 1) return { message: input.capacityMessage ?? '生成できる枚数を確認しています。しばらくお待ちください。' };
  if (input.styleMode === 'manual' && input.styleCount === 0) return { message: 'スタイルを選ぶか、選んだスタイルを解除してください。', target: 'style' };
  if (input.styleCount > input.imageCount) return { message: `スタイルを${input.styleCount}件選んでいます。生成枚数を${input.styleCount}枚以上にしてください。`, target: 'count' };
  if (input.productFetching && input.styleMode !== 'manual') {
    return { message: '商品情報を取得しています。終わると商品に合うスタイルで生成できます（スタイルを選べば今すぐ生成できます）。', target: 'style' };
  }
  if (input.sizeError) return { message: input.sizeError, target: 'size' };
  return null;
}
